import * as z from "zod";

export const LicensePlateTemplate = {
  full: "full",
  itemIdOnly: "item-id-only",
} as const;

export type LicensePlateTemplate =
  (typeof LicensePlateTemplate)[keyof typeof LicensePlateTemplate];

export const LicensePlateTemplateSchema = z.enum(LicensePlateTemplate);

export const defaultLicensePlateTemplate = LicensePlateTemplate.full;
